import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  width: 100%;
  /* border: 4px solid red; */
`;
